import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AdminService } from '../services/admin.service';
import { UserAdminDTO } from '../model/UserAdminDTO';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-admin-users-details',
  imports: [NgIf, NgFor, FormsModule, CommonModule],
  templateUrl: './admin-users-details.component.html',
  styleUrls: ['./admin-users-details.component.css']
})
export class AdminUsersDetailsComponent implements OnInit {
  user: UserAdminDTO | null = null; // Datos originales del usuario
  editableUser: UserAdminDTO = {
    id: '0',
    username: '',
    email: '', 
    role: 'USER', 
    enabled: false,
    nacionalidad: '',
    facebook: '',
    instagram: '',
    twitter: '',
    imgPerfil: '',
    imgBanner: '',
    accountNonExpired: false,
    accountNonLocked: false,
    credentialsNonExpired: false,
    createdAt: new Date(),
    updatedAt: new Date()};
   
  errorMessage: string = '';
  isEditing: boolean = false;

  constructor(private route: ActivatedRoute, private adminService: AdminService) {}

  ngOnInit(): void {
    const userId = this.route.snapshot.paramMap.get('id');
    if (userId) {
      this.fetchUserDetails(userId);
    }
  }

  fetchUserDetails(userId: string): void {
    this.adminService.getUserById(userId).subscribe({
      next: (data: UserAdminDTO) => {
        this.user = data;
      },
      error: (error: any) => {
        this.errorMessage = 'Error fetching user details';
        console.error(error);
      }
    });
  }

  enableEditing(): void {
    if (this.user) {
      this.editableUser = { ...this.user };
      this.isEditing = true;
    }
  }

  saveChanges(): void {
    if (this.user && this.editableUser) {
      this.adminService.updateUser(this.user.id, this.editableUser).subscribe({
        next: () => {
          this.isEditing = false;
          if (this.user && this.editableUser) {
            this.user = { ...this.editableUser, id: this.user.id };
          }
          alert('User updated successfully!');
        },
        error: (error: any) => {
          this.errorMessage = 'Error updating user';
          console.error(error);
        }
      });
    }
  }
}